import React from 'react'
import { webSocket } from './socket'

export var authResponse, forgotPasswordResponse, createCustomerResponse;

export const login = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'LoginRequest': data }));
        authResponse = resolve;
    });
    return promise;
}

export const sendForgotPassword = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'ForgotPassword': data }));
        forgotPasswordResponse = resolve;
    });
    return promise;
}

export const forgotPassword = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendForgotPassword(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendCreateCustomer = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'createCustomer': data }));
        createCustomerResponse = resolve;
    });
    return promise;
}

export const createCustomer = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendCreateCustomer(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const verificationCode = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'sendVerificationCode': data }));
        createCustomerResponse = resolve;
    });
    return promise;
}

export const sendVerificationCode = (data) => {
    const promise = new Promise(function(resolve, reject) {
        verificationCode(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}



